import type { FC, ReactNode } from 'react'

import { AnimatePresence, motion } from 'motion/react'
import { Rotate3d } from 'lucide-react'

const EASE = [0.22, 1, 0.36, 1] as const

interface DragHintProps {
    // Shown once the 3D piece is ready, hidden for good after the first drag.
    show: boolean
}

// A small tag under a page header's 3D piece telling visitors they can turn it by hand.
// Purely visual: pointer events pass through to the piece underneath.
const DragHint: FC<DragHintProps> = ({ show }): ReactNode => {
    return (
        <AnimatePresence>
            {show && (
                <motion.span
                    aria-hidden='true'
                    initial={{ opacity: 0, y: 8 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: 4, transition: { duration: 0.4, ease: EASE } }}
                    transition={{ duration: 0.8, delay: 0.6, ease: EASE }}
                    className='pointer-events-none absolute bottom-0 left-1/2 z-20 flex -translate-x-1/2 items-center gap-1.5 whitespace-nowrap rounded-full bg-white px-3 py-1 text-[12px] font-medium text-cocoa shadow-[0_6px_18px_-8px_rgb(74_43_32/0.45)]'
                >
                    <Rotate3d className='size-4' strokeWidth={1.75} />
                    Drag to turn
                </motion.span>
            )}
        </AnimatePresence>
    )
}

export default DragHint
